export default "__VITE_ASSET__evJPKRmf__"